import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgChevronBackSider = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 20,
	height: 20,
	viewBox: "0 0 20 20",
	fill: "none",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M12.5 15L7.5 10L12.5 5",
		stroke: "white",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
});
export default SvgChevronBackSider;
